import * as actionType from "./actionTypes";
import { createReducer, updateObject } from "../../utils/reducerUtils";

/* State shape same as initial state
*/
const initialState = {
  authToken: null,
  hasCheckedAuth: false,
  //{ email, firstName, lastName, marketingOptIn, isAdmin }
  profile: null,
};

const updateAuthToken = (state, action) => (
  updateObject(state, {
    authToken: action.token,
    profile: action.token ? state.profile : null,
  })
);

const updateHasCheckedAuth = (state) => (
  updateObject(state, {
    hasCheckedAuth: true,
  })
);

const setProfile = (state, action) => (
  updateObject(state, {
    profile: action.profile,
  })
);

const reducer = createReducer(initialState, {
  [actionType.SET_AUTH_TOKEN]: updateAuthToken,
  [actionType.SET_HAS_CHECKED_AUTH]: updateHasCheckedAuth,
  [actionType.SET_PROFILE]: setProfile,
});

export default reducer;

// SELECTORS
export const getAuthToken = (state) => (
  state.authToken
);

export const getHasCheckedAuth = (state) => (
  state.hasCheckedAuth
);

export const getProfile = (state) => (
  state.profile
);

export const getIsAuthed = (state) => (
  (state.authToken !== null) && (state.profile !== null)
);
